/**
 * 지도 후 차감 관리 목록
 */
import React, { Component } from 'react';
import { Navbar, ListGroup, Form, ButtonToolbar, ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faArrowCircleLeft, faAngleRight, faCheckCircle, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import SideMenuCmp from './SideMenuCmp';
import $ from 'jquery';
import { udfAutoLogin, url, udfInlineLoading, udfNoneLoading, openAlert, openConfirm } from '../../common/common';
import { udfSetHakgwaList, udfSetLastBan, sc_deduct, udfSetScInfo, udfSetSearchCondition } from '../../common/usr/stdtList'
import loader from '../../imgs/ajax-loader.gif';
import { dropByCacheKey } from 'react-router-cache-route'

let firstIndex = 0;	// 불러 올 시작 레코드
const recordCountPerPage = 15;	// 한번에 불러 올 레코드 개수
let isMore = true;	// 불러 올 레코드 존재 여부
let isRunning = false;
let isLogging = false;

let that = this;

class DeductListCmp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // bootstrap Alert 변수
      alertShow: false,
      alertClickNo: null,
      alertClickYes: null,
      alertClickOk: null,
      alertMessage: null,

      list: [],
      usrInfo: null,
    }
  }

  componentDidMount = () => {
    udfNoneLoading();
    if (isMore && !isRunning && !isLogging) {
      isLogging = true;
      // 자동 로그인 체크
      udfAutoLogin(this).then((data) => {
        if (data !== null && data.userSe === 'STDT') {
          this.props.history.push('/stdt/ruleList');
        } else if (data !== null && data.userSe === 'USR') {
          isLogging = false;
          this.setState({ usrInfo: data });
          this.udfSelectDeductList('Y');
        } else {
          this.props.history.push('/');
        }
      });
    }

    // 케시된 페이지 DROP
    dropByCacheKey('noticeCachce');
    dropByCacheKey('qnaCachce');
    dropByCacheKey('newsCachce');
    dropByCacheKey('stdtListCachce');
    dropByCacheKey('ruleRptCachce');
    dropByCacheKey('ruleHistoryCachce');

    if (this.state.list.length === 0) {
      isMore = true;
      isRunning = false;
      firstIndex = 0;
    }

    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount = () => {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    if ($('.wrap-loading').length - $('.wrap-loading.d-none').length !== 0 || $('.modal-backdrop.show').length > 0)
      return false;

    let marginBottom = 71;
    if (window.innerHeight + marginBottom >= Math.ceil(document.getElementsByTagName('body')[0].getBoundingClientRect().bottom) && isMore) {
      this.udfSelectDeductList('N');
    }
  }

  // 지도/상담 수정 권한
  JG_U_YN_FLAG = false;

  // 조회
  udfSelectDeductList = (clearYn) => {
    if (!this.state.usrInfo || isLogging) return;

    if (clearYn === 'Y') {
      firstIndex = 0;
      isMore = true;
      $(window).scrollTop(0);
    }

    that = this;
    if (isMore && !isRunning) {
      udfInlineLoading();
      isRunning = true;

      let setData = {
        isMobile: 'Y',
        firstIndex: firstIndex,
        recordCountPerPage: recordCountPerPage,
        SF_HAKGWA: sc_deduct.SF_HAKGWA,
        SF_GRADE: sc_deduct.SF_GRADE,
        SF_START_BAN: sc_deduct.SF_START_BAN,
        SF_END_BAN: sc_deduct.SF_END_BAN,
        SF_JG_APLY_YN: sc_deduct.SF_JG_APLY_YN,
        SF_JG_EDATE: sc_deduct.SF_JG_EDATE
      };

      $.ajax({
        url: url + '/sli/cnsl/selectDeductList.do',
        type: 'GET',
        dataType: 'jsonp',
        data: setData,
        success: function (data) {
          udfNoneLoading();

          if (!data.success)
            that.componentDidMount();
          else {
            let list = [];
            let hakgwaList = [];

            // 지도/상담 수정 권한
            if (data.ESNTL_GU === 'T' && data.JG_U_YN === 'N') that.JG_U_YN_FLAG = false;
            else that.JG_U_YN_FLAG = true;

            if (data.resultList !== undefined && data.resultList !== null) {
              var idx = firstIndex;
              $.each(data.resultList, function (i, val) {
                idx++;

                list.push({
                  STD_CD: val.STD_CD,
                  HAKGWA: val.HAKGWA,
                  GRADE: val.GRADE,
                  BAN: val.BAN,
                  BUN: val.BUN,
                  STD_NM: val.STD_NM,
                  JG_EDATE: val.JG_EDATE,
                  CNSL_DESC: val.CNSL_DESC,
                  JG_DESC: val.JG_DESC,
                  JG_SDATE: val.JG_SDATE,
                  JG_POINT: val.JG_POINT,
                  ESNTL_NM: val.ESNTL_NM,
                  JG_DATE: val.JG_DATE,
                  JG_SEQ: val.JG_SEQ,
                });
              });

              // 학과 목록
              udfSetHakgwaList(hakgwaList);
              $.each(data.hakgwaList, function (i, v) {
                hakgwaList.push(v.HAKGWA);
              });

              udfSetHakgwaList(hakgwaList);

              // 마지막 반
              udfSetLastBan(data.lastBan);

              if (idx - firstIndex !== recordCountPerPage) isMore = false;
              firstIndex += recordCountPerPage;

              if (clearYn !== 'Y') list = that.state.list.concat(list);

              udfSetSearchCondition('deduct', 'SF_JG_EDATE', data.SF_JG_EDATE);

              if (sc_deduct.SF_START_BAN === '') {
                udfSetSearchCondition('deduct', 'SF_START_BAN', 1);
                udfSetSearchCondition('deduct', 'SF_START_BAN_NM', '1반');
              }

              that.setState({
                isLoggedIn: true,
                list: list,
                alertShow: false,
              });

              udfSetScInfo('deduct', false, false);
            }
          }

          if ($('#select_Y').hasClass('active')) that.fn_select_cnsl_all('Y');
          if ($('#select_N').hasClass('active')) that.fn_select_cnsl_all('N');

          isRunning = false;
        },
        error: function (jqXHR, status, error) {
          isRunning = false;
          that.componentDidMount();
          udfNoneLoading();
        }
      });
    }
  }

  // 하나 선택
  fn_select = (e, row) => {
    if (e === null) {
      $("input[name=STD_LIST]")[row].checked = !$("input[name=STD_LIST]")[row].checked;
    } else e.stopPropagation();

    if ($($("input[name=STD_LIST]")[row]).is(':checked')) {
      $('#ls_' + row).addClass('cnsl-selected');
    } else $('#ls_' + row).removeClass('cnsl-selected');
  }

  // 전체 선택/해제
  fn_select_cnsl_all = (val) => {
    if (val === 'Y') val = true;
    else val = false;

    $("input[name=STD_LIST]").prop("checked", val);

    for (let i = 0; i < this.state.list.length; i++) {
      if (val) $('#ls_' + i).addClass('cnsl-selected');
      else $('#ls_' + i).removeClass('cnsl-selected');
    }
  }

  // 차감 적용/취소 MODAL
  fn_updateAlert = () => {
    if (!this.JG_U_YN_FLAG) {
      openAlert(this, '수정 권한이 없습니다. 학교관리자에게 문의하여 주시기 바랍니다.');
      return;
    }

    let cnt = 0;
    $.each($("input[name=STD_LIST]"), function (i, v) {
      if ($(v).is(':checked')) cnt++;
    });

    if (cnt === 0) {
      openAlert(that, '학생을 선택해주세요.');
      return;
    }

    let msg = '차감 적용 하시겠습니까?';
    if (sc_deduct.SF_JG_APLY_YN === 'Y') msg = '차감 취소 처리 하시겠습니까?';

    openConfirm(this, msg, this.fn_update);
  }

  // 차감 적용/취소
  fn_update = () => {
    let stdtList = [];
    $.each($("input[name=STD_LIST]"), function (i, v) {
      if ($(v).is(':checked')) stdtList.push($(v).val());
    });

    that = this;
    $.ajax({
      url: url + '/sli/cnsl/updateDeduct.do',
      type: 'GET',
      dataType: 'jsonp',
      traditional: true,
      data: {
        isMobile: 'Y',
        SF_JG_APLY_YN: sc_deduct.SF_JG_APLY_YN,
        STD_LIST: stdtList,
        SF_JG_EDATE: sc_deduct.SF_JG_EDATE,
      },
      success: function (data) {
        udfNoneLoading();
        isRunning = false;

        if (!data.success)
          that.componentDidMount();
        else {
          if (data.result > 0) {
            that.udfSelectDeductList('Y');
          } else {
            openAlert(that, '처리 도중 오류가 발생했습니다. 다시 시도해주세요.');
          }
        }
      },
      error: function (jqXHR, status, error) {
        udfNoneLoading();
        isRunning = false;
        that.componentDidMount();
      }
    });
  }

  render() {
    return (
      <>
        {/* to the top */}
        <div className='btn-to-top' onClick={() => $(window).scrollTop(0)}><FontAwesomeIcon icon={faAngleUp} /></div>
        {/* 차감적용/취소 */}
        <div className='btn-rule-add' onClick={() => this.fn_updateAlert()}><FontAwesomeIcon icon={faCheckCircle} /></div>

        <div className='wrap-loading'>
          <img src={loader} alt='로딩 이미지' />
        </div>

        {/* header */}
        <Navbar fixed='top' className='title'>
          <div className="goBackBtn"><div style={{ color: '#fff' }}><FontAwesomeIcon icon={faArrowCircleLeft} className="btn-home" /></div></div>
          지도 후 차감 관리
          <SideMenuCmp
            history={this.props.history}
            usrInfo={this.state.usrInfo}
            alertShow={this.state.alertShow}
            alertMessage={this.state.alertMessage}
            alertClickOk={this.state.alertClickOk}
            alertClickYes={this.state.alertClickYes}
            alertClickNo={this.state.alertClickNo}
          />
        </Navbar>

        {/* 검색조건 */}
        <ListGroup variant='flush' style={{ marginTop: '55px' }}>
          <ListGroup.Item className='searchSummary text-muted' onClick={() => this.props.history.push('/usr/deductSearch')}>
            <FontAwesomeIcon icon={faSearch} className='mr-2' />
            {sc_deduct.SF_HAKGWA_NM}&nbsp;·&nbsp;
            {sc_deduct.SF_GRADE_NM}&nbsp;·&nbsp;
            {sc_deduct.SF_START_BAN_NM}~
            {sc_deduct.SF_END_BAN_NM}&nbsp;·&nbsp;
            {sc_deduct.SF_JG_APLY_YN_NM}&nbsp;·&nbsp;
            {sc_deduct.SF_JG_EDATE}까지
          </ListGroup.Item>
        </ListGroup>

        <ButtonToolbar className='mt-2 mb-2' style={{ padding: '0 15px' }}>
          <ToggleButtonGroup type="radio" name="options1" defaultValue={['Y']} style={{ width: '100%' }} >
            <ToggleButton variant="light" className="col" value={'Y'} id='select_Y' onClick={() => this.fn_select_cnsl_all('Y')}>전체 선택</ToggleButton>
            <ToggleButton variant="light" className="col" value={'N'} id='select_N' onClick={() => this.fn_select_cnsl_all('N')}>전체 선택 해제</ToggleButton>
          </ToggleButtonGroup>
        </ButtonToolbar>

        <div className='container-fluid' style={{ padding: '0' }}>
          {
            this.state.list.map((data, idx) => (
              <div
                key={idx}
                id={`ls_${idx}`}
                className='row'
                style={{ lineHeight: '180%', margin: '0', padding: '0.75rem 15px' }}
                onClick={() => this.fn_select(null, idx)}
              >
                <div className='pl-2 col-1'>
                  <Form.Check
                    inline
                    name='STD_LIST'
                    disabled={data.JG_EDATE === '' || data.JG_EDATE === undefined ? 'disabled' : ''}
                    type='checkbox'
                    onClick={(e) => this.fn_select(e, idx)}
                    value={`${data.STD_CD}-${data.JG_DATE}-${data.JG_SEQ}`}
                  />
                </div>
                <div className='col' style={{ paddingLeft: '0' }}>
                  <div>{data.HAKGWA}{data.HAKGWA !== undefined ? ' ' + data.GRADE : data.GRADE}학년 {data.BAN}반 {data.BUN}번 {data.STD_NM}</div>
                  <div>
                    <div className="font-weight-bold">{data.JG_DATE} {data.JG_TIME}</div>
                    <dl>
                      <dt className="font-weight-normal"><FontAwesomeIcon icon={faAngleRight} /> 상담내용</dt>
                      <dd className="pl-4" style={{ wordBreak: 'break-all' }}>{data.CNSL_DESC}</dd>
                      <dt className="font-weight-normal"><FontAwesomeIcon icon={faAngleRight} /> 지도내용</dt>
                      <dd className="pl-4" style={{ wordBreak: 'break-all' }}>{data.JG_DESC}</dd>
                      <dt className="font-weight-normal"><FontAwesomeIcon icon={faAngleRight} /> 지도기간</dt>
                      <dd className="pl-4">{data.JG_SDATE} {data.JG_EDATE !== '' ? '~ ' + data.JG_EDATE : ''}</dd>
                      <dt className="font-weight-normal"><FontAwesomeIcon icon={faAngleRight} /> 지도차감점수</dt>
                      <dd className="pl-4"><span className="point" style={{ float: 'unset' }}>{data.JG_POINT} 점</span></dd>
                    </dl>
                  </div>
                </div>
              </div>
            ))
          }
        </div>
      </>
    );
  }
}

export default DeductListCmp;